import { createAsyncThunk, createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fnDictGetIndex, fnJSONParse, fnDictSetIndex, timestampWithMilliseconds, fnCompareArrayElements } from '@rhino/shared/services/shared';
import { addToQueue } from '@rhino/shared/services/redux/prefsSlice';
import { AppDispatch, RootState } from './store';
import { deepMerge, isObject } from '@rhino/shared/services/helpers';
import { fnAdmin_PullPageSettings } from '@rhino/shared/services/sputnikapi';
// import { useAppDispatch } from '@rhino/shared/services/redux/hooks';
// import { SputnikDeviceAttributes } from './sputnikdevicesSlice';
import { SputnikDevice } from '../../components/nebulon/sputnikDeviceTypes';
import { SputnikDeviceStatus } from '../../components/nebulon/sputnikDeviceTypes';
import { Key } from 'react';
// import { PropaneSharp } from '@mui/icons-material';

interface TilePosition {
  order: number;
  height: number;
  width: number; 
}

export type ElementVisibility = Key[];
export type ElementRollups = { [key: string]: {expanded:boolean,tileDims:{tileHeight?:number,tileWidth?:number}} };
interface NebulonSpreadTile {
  nebulonTileID: string;
  tileName: string;
  roomName: string;
  visibility: ElementVisibility;
  childTiles?: NebulonTile[]; // New property to hold wrapped tiles
}

export interface NebulonSputnikTrends { [trendId: string]: NebulonSputnikTrend }
export interface NebulonSputnikTrend { 
  trendMetricName?: string;
  tab?:string;
  title?:string;
  yAxisFormat?:string;
  }
export interface NebulonTile {
  nebulonTileID: string;
  sputnikDeviceCode?: string;
  trends:NebulonSputnikTrends
  tileName: string;
  roomName: string;
  tileType: string;
  position?: TilePosition;
  visibility: ElementVisibility;
  rollUps: ElementRollups;
  sputnikDevice: SputnikDevice;
  tileState?: string;
  prefs?: { [key: string]: any };
  tileSpread?: NebulonSpreadTile[]; // Adjusted to hold an array of NebulonSpreadTile
  order?: number
}

export interface NebulonSpread {
  name: string;
  sputnikDevices?:any; 
  trendMetrics?:any;
  tiles: { [id: string]: NebulonTile };
  rooms: { [id: string]: NebulonTile };
}
// Define an enumeration for monitor types
export enum TileType {
  Default = "default",
  Trend= 'trend',
}
export const tileElementIsShown = (
  visibleComponentSelections: ElementVisibility,
  elementTag: string | string[],
  allMatch: boolean = false // default to false if not provided
): boolean => {
  if (visibleComponentSelections.length === 0) return true;
  const tags = typeof elementTag === 'string' ? [elementTag] : elementTag;
  return allMatch ? tags.every(tag => visibleComponentSelections.includes(tag)) : tags.some(tag => visibleComponentSelections.includes(tag));
};

// Currying the function
export const createTileElementVisibilityChecker = (visibleComponentSelections: ElementVisibility) => {
  return (elementTag:string | string[], allMatch:boolean = false) => {
    return tileElementIsShown(visibleComponentSelections, elementTag, allMatch);
  };
};

export const updateNebulonRoomSettingAsync = createAsyncThunk(
  "nebulonspread/setRoomProperty",
  async (payload: { roomName: string, keyaddress: string; keyvalue: any }, thunkAPI) => {
    const { dispatch, getState } = thunkAPI;
    
    try {
      console.log(payload)
      const state = getState() as RootState;
      const existingValue = fnDictGetIndex(state.nebulonspread,`rooms.${payload.roomName}.${payload.keyaddress}`);
      let mergedValue;

      // Check if both existing value and payload are objects for merging
      if (existingValue && isObject(existingValue) && isObject(payload.keyvalue)) {
        // console.log('its deep',existingValue,typeof(existingValue),Array.isArray(existingValue),payload.keyvalue,typeof(payload.keyvalue),Array.isArray(payload.keyvalue))
        mergedValue = deepMerge(existingValue, payload.keyvalue);
      } else {
        // console.log('its shallow')
        mergedValue = payload.keyvalue;
      }

      dispatch(nebulonspreadSlice.actions.setRoomProperty({
          roomName: payload.roomName,
          keyaddress: payload.keyaddress,
          keyvalue: mergedValue
        }));

      // Send merged value to the server
      // console.log('send update to server',`${state.nebulonspread.name}.${payload.nebulonTileID}.${payload.keyaddress}`, mergedValue);
      dispatch(addToQueue({
        type: 7,
        prefname: `${state.nebulonspread.name}.rooms.${payload.roomName}`,
        keyaddress: payload.keyaddress,
        keyvalue: mergedValue
      }));

    } catch (oErr) {
      console.error(oErr);
    }
  }
);
export const updateNebulonTileSettingAsync = createAsyncThunk(
  "nebulonspread/setTileProperty",
  async (payload: { nebulonTileID: string, keyaddress: string; keyvalue: any; isRoom?:boolean }, thunkAPI) => {
    const { dispatch, getState } = thunkAPI;
    
    try {
      // console.log(payload)
      const state = getState() as RootState;
      const existingValue = fnDictGetIndex(state.nebulonspread,`${payload.isRoom ? 'rooms':'tiles'}.${payload.nebulonTileID}.${payload.keyaddress}`);
      // console.log(`The change is between ${payload.isRoom ? 'rooms':'tiles'}.${payload.nebulonTileID}.${payload.keyaddress}`
      //   ,existingValue,payload.keyvalue,`Are the same? :${fnCompareArrayElements(existingValue, payload.keyvalue)}`)

      let mergedValue;

      // Check if both existing value and payload are objects for merging
      if (existingValue && isObject(existingValue) && isObject(payload.keyvalue)) {
        // console.log('its deep',existingValue,typeof(existingValue),Array.isArray(existingValue),payload.keyvalue,typeof(payload.keyvalue),Array.isArray(payload.keyvalue))
        mergedValue = deepMerge(existingValue, payload.keyvalue);
      } else {
        // console.log('its shallow')
        mergedValue = payload.keyvalue;
      }
      // console.log(`Are the same? :${fnCompareArrayElements(mergedValue, existingValue)}`)
      // Dispatch action with merged value
      // console.log(payload.keyaddress,mergedValue)
      if (fnCompareArrayElements(mergedValue, existingValue)) {return}
      if (payload.isRoom) {  
        // Dispatch the action to set the tile property
        dispatch(nebulonspreadSlice.actions.setRoomProperty({
          roomName: payload.nebulonTileID,
          keyaddress: payload.keyaddress,
          keyvalue: mergedValue
        }));
      } else {
        dispatch(setTileProperty({
          nebulonTileID: payload.nebulonTileID,
          keyaddress: payload.keyaddress,
          keyvalue: mergedValue
        }));
  
      }

      // Send merged value to the server
      // console.log('send update to server',`${state.nebulonspread.name}.${payload.nebulonTileID}.${payload.keyaddress}`, mergedValue);
      dispatch(addToQueue({
        type: 7,
        prefname: `${state.nebulonspread.name}.${payload.isRoom ? 'rooms':'tiles'}.${payload.nebulonTileID}`,
        keyaddress: payload.keyaddress,
        keyvalue: mergedValue
      }));

    } catch (oErr) {
      console.error(oErr);
    }
  }
);
export const updateNebulonTileSputnikDeviceStatusAsync = createAsyncThunk(
  "nebulonspread/setTileDeviceStatus",
  async (payload: { nebulonTileID: string, keyaddress: string; keyvalue: any;actionCommand?:string }, thunkAPI) => {
    const { dispatch, getState } = thunkAPI;
    
    try {
      // console.log('start')
      const { keyvalue, nebulonTileID,keyaddress,actionCommand } = payload;
      let mergedValue = keyvalue;
      // Check if both existing value and payload are objects for merging
      const state = getState() as RootState;
      if (typeof mergedValue === 'object') {
        const existingValue = fnDictGetIndex(state.nebulonspread.tiles[Number(nebulonTileID)]?.sputnikDevice?.status,keyaddress);
        if (existingValue && typeof existingValue === 'object') {
          console.log('deep merge')
          mergedValue = deepMerge(existingValue, keyvalue);
        }
      };
      let sDeviceCode = ''
      if (nebulonTileID) {
        // Dispatch action with merged value
        dispatch(setTileProperty({
          nebulonTileID: nebulonTileID,
          keyaddress: `sputnikDevice.status.${keyaddress}`,
          keyvalue: mergedValue
        }));
        sDeviceCode = state.nebulonspread.tiles[nebulonTileID]?.sputnikDeviceCode||''
      }
      // console.log('finish')

      // Send merged value to the server
      // console.log('send update to server',`${state.nebulonspread.name}.${nebulonTileID}.${keyaddress}`, mergedValue);
      
      if (sDeviceCode) {
        dispatch(addToQueue({
          type: 8, 
          prefname: sDeviceCode,
          keyaddress: keyaddress,
          keyvalue: mergedValue,
          tagid: timestampWithMilliseconds(),
        }));
      }

    } catch (oErr) {
      console.error(oErr);
    }
  }
);

export const fetchSpreadDetails = createAsyncThunk(
  "nebulonspread/fetchDetails",
  async (spread: NebulonSpread, thunkAPI) => {
    try {
      const dispatch = thunkAPI.dispatch as AppDispatch;

      dispatch(setSpread(spread));
      await fetchAndUpdateDeviceDetails(spread.tiles, dispatch);
    } catch (error) {
      console.error("Error fetching spread details:", error);

      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const setTilesByDeviceCode = createAsyncThunk(
  "nebulonspread/setTilesByDeviceCode",
  async (payload: { sputnikDeviceCode: string, keyaddress: string, keyvalue: any }, thunkAPI) => {
    const getState = thunkAPI.getState;
    const dispatch = thunkAPI.dispatch as AppDispatch;

    const state = getState() as RootState;
    if (payload.sputnikDeviceCode) {
      // find all the tiles that have this device code
      for (let tileID in state.nebulonspread.tiles) {
        const tile = state.nebulonspread.tiles[tileID];
        if (tile.sputnikDeviceCode === payload.sputnikDeviceCode) {
          // console.log('Found device by code')
          dispatch(setTileProperty({ nebulonTileID: tileID, keyaddress: payload.keyaddress, keyvalue: payload.keyvalue }));
        }
      }
    
    } 
  }
)
export const setTileProperty = createAsyncThunk(
  "nebulonspread/setTileProperty",
  async (payload: { nebulonTileID: string, keyaddress: string, keyvalue: any }, thunkAPI) => {
    const getState = thunkAPI.getState;
    const dispatch = thunkAPI.dispatch as AppDispatch;

    // Dispatch the action to set the tile property
    dispatch(nebulonspreadSlice.actions.setTileProperty(payload));

    const state = getState() as RootState;
    const tile = state.nebulonspread.tiles[payload.nebulonTileID];

    if (tile.sputnikDeviceCode) {
      const needsUpdate = !tile.sputnikDevice || tile.sputnikDevice.sputnikDeviceCode !== tile.sputnikDeviceCode;
      if (needsUpdate) {
        const singleTile = { [Number(payload.nebulonTileID)]: tile };
        // console.log('getting update')
        await fetchAndUpdateDeviceDetails(singleTile, dispatch);
      }
    } else if (tile.sputnikDevice) {
      dispatch(nebulonspreadSlice.actions.setTileProperty({ 
        nebulonTileID: payload.nebulonTileID, 
        keyaddress: 'sputnikDevice', 
        keyvalue: undefined 
      }));
    }
  }
);
export const setRoomProperty = createAsyncThunk(
  "nebulonspread/setRoomProperty",
  async (payload: { roomName: string, keyaddress: string, keyvalue: any }, thunkAPI) => {
    const getState = thunkAPI.getState;
    const dispatch = thunkAPI.dispatch as AppDispatch;

    // Dispatch the action to set the tile property
    dispatch(nebulonspreadSlice.actions.setRoomProperty(payload));
  }
);
export const setTile = createAsyncThunk(
  "nebulonspread/setTile",
  async (payload: { nebulonTileID: string, attributes: any }, thunkAPI) => {
    const getState = thunkAPI.getState;
    const dispatch = thunkAPI.dispatch as AppDispatch;

    // Dispatch the action to set the tile property
    dispatch(nebulonspreadSlice.actions.setTile(payload));

    const state = getState() as RootState;
    const tile = state.nebulonspread.tiles[payload.nebulonTileID];

    if (tile.sputnikDeviceCode) {
      const needsUpdate = !tile.sputnikDevice || tile.sputnikDevice.sputnikDeviceCode !== tile.sputnikDeviceCode;
      if (needsUpdate) {
        const singleTile = { [payload.nebulonTileID]: tile };
        await fetchAndUpdateDeviceDetails(singleTile, dispatch);
      }
    } else if (tile.sputnikDevice) {
      dispatch(nebulonspreadSlice.actions.setTileProperty({ 
        nebulonTileID: payload.nebulonTileID, 
        keyaddress: 'sputnikDevice', 
        keyvalue: undefined 
      }));
    }
  }
);

const initialState: NebulonSpread = {
  name:"",
  tiles: {},
  rooms: {}
};

const nebulonspreadSlice = createSlice({
  name: 'nebulonspread',
  initialState,
  reducers: {
    setTileProperty: (state, action: PayloadAction<{ nebulonTileID: string, keyaddress: string, keyvalue: any }>) => {
      const { nebulonTileID, keyaddress, keyvalue } = action.payload;
      fnDictSetIndex(state.tiles, `${nebulonTileID}.${keyaddress}`, keyvalue);
    },
    setRoomProperty: (state, action: PayloadAction<{ roomName: string, keyaddress: string, keyvalue: any }>) => {
      const { roomName, keyaddress, keyvalue } = action.payload;
      fnDictSetIndex(state.rooms, `${roomName}.${keyaddress}`, keyvalue);
    },    
    setTileState: (state, action: PayloadAction<{ nebulonTileID: string, tileState: string }>) => {
      state.tiles[Number(action.payload.nebulonTileID)].tileState=action.payload.tileState
    },

    setTile: (state, action: PayloadAction<{ nebulonTileID: string, attributes: any }>) => {
      const { nebulonTileID, attributes } = action.payload;
      fnDictSetIndex(state.tiles, `${nebulonTileID}`, attributes);
      // console.log("Updated state",nebulontileid,attributes)
    },
    setSpread: (state, action: PayloadAction<NebulonSpread>) => {
      state.tiles = action.payload.tiles;
      state.rooms = action.payload.rooms;
      state.name = action.payload.name;
    },
    setSputnikDevices: (state, action: PayloadAction<any>) => {
      // console.log(action.payload)
      state.sputnikDevices = action.payload;
    },
    setSputnikTrends: (state, action: PayloadAction<any>) => {
      // console.log(action.payload)
      state.trendMetrics = action.payload;
    },    
    
  }
});

export const {
  setSpread,
  setSputnikDevices,
  setSputnikTrends,
  setTileState,
} = nebulonspreadSlice.actions;
export const selectNebulonTileAttributes  = (state:RootState, nebulonTileID: string): NebulonTile | undefined => {
  // console.log(state,state.nebulonspread,Number(nebulonTileID))
  return state.nebulonspread?.tiles[nebulonTileID];
};
export const selectNebulonSpreadTiles  = (state:RootState,): { [id: string]: NebulonTile } | undefined => {
  return state.nebulonspread?.tiles;
};
export const selectNebulonRoomAttributes  = (state:RootState, roomName: string): NebulonTile | undefined => {
  // console.log(state,state.nebulonspread,Number(nebulonTileID))
  return state.nebulonspread?.rooms[roomName];
};
export const selectNebulonSpreadRooms  = (state:RootState,): { [id: string]: NebulonTile } | undefined => {
  return state.nebulonspread?.rooms;
};
export const selectNebulonTileSputnikDeviceStatus  = (state:RootState, nebulonTileID: string): SputnikDeviceStatus | undefined => {
  // console.log(state.nebulonspread?.tiles[Number(nebulonTileID)]?.sputnikDevice?.status,Number(nebulonTileID))
  return state.nebulonspread?.tiles[nebulonTileID]?.sputnikDevice?.status;
};
export const selectSputnikDevices = (state: RootState) => {
  return state.nebulonspread?.sputnikDevices;
}

export const selectTrendMetrics = (state: RootState) => {
  return state.nebulonspread?.trendMetrics;
}


  
export default nebulonspreadSlice.reducer;

// export const extractUniqueRoomNames = createSelector(
//   (state: RootState) => state.nebulonspread.tiles,
//   (tiles) => {
//       const roomNames = new Set<string>();
//       Object.values(tiles).forEach(tile => {
//           if (tile.roomName) {
//               roomNames.add(tile.roomName);
//           }
//       });
//       return roomNames;
//   }
// );

// export const groupTilesByRoomSelector = createSelector(
//   (state: RootState) => state.nebulonspread.tiles,
//   (state: RootState) => state.nebulonspread.rooms,
//   (tiles, rooms) => {
//     const groupedByRoom = Object.entries(tiles).reduce((acc, [key, tile]) => {
//       const room = tile.roomName || 'None';
//       if (!acc[room]) {
//         acc[room] = [];
//       }
//       acc[room].push(key); // Push the key, not the entire tile object
//       return acc;
//     }, {} as Record<string, string[]>);

//     const roomsWithOrder = Object.entries(rooms).map(([roomName, roomDetails]) => ({
//       roomName,
//       roomOrder: roomDetails?.prefs?.order || -1, // Use -1 or similar for rooms without order to sort them first
//     }));
//     // Step 3: Sort the roomsWithOrder array based on roomOrder
//     roomsWithOrder.sort((a, b) => a.roomOrder - b.roomOrder);
//     // Step 4: Create a new sorted grouping based on the sorted rooms
//     const sortedGroupedByRoom: Record<string, string[]> = {};
//     roomsWithOrder.forEach(({ roomName }) => {
//       if (groupedByRoom[roomName]) { // If the room has tiles grouped
//         sortedGroupedByRoom[roomName] = groupedByRoom[roomName];
//       }
//     });

//     // Step 5: Add any additional groups (rooms) that might not have been in the rooms object
//     Object.keys(groupedByRoom).forEach(roomName => {
//       if (!sortedGroupedByRoom[roomName]) { // If not already added through sorting
//         sortedGroupedByRoom[roomName] = groupedByRoom[roomName];
//       }
//     });

//     return sortedGroupedByRoom;
//   }
// );

// Create a set of unique sputnik device codes
async function fetchAndUpdateDeviceDetails(
  tiles: Record<number, NebulonTile>, 
  dispatch: AppDispatch
) {
  const tSputnikdevicecodes = new Set<string>();
  const tLookup: Record<string, string[]> = {};
      
  Object.entries(tiles).forEach(([nebulonTileID, tile]) => {
      if (tile.sputnikDeviceCode) {
          tSputnikdevicecodes.add(tile.sputnikDeviceCode);
          
          if (tLookup[tile.sputnikDeviceCode]) {
              tLookup[tile.sputnikDeviceCode].push(nebulonTileID);
          } else {
              tLookup[tile.sputnikDeviceCode] = [nebulonTileID];
          }
      }
  });

  fnAdmin_PullPageSettings('sputnikdevices', dispatch,{sputnikdevicecodes:Array.from(tSputnikdevicecodes)})
    .then(response => {
          // console.log(response)
          if (response.success) {
              // console.log(response.data)

              response.data.forEach((deviceData:[number, string, string, string, string]) => {
                const [sputnikdeviceid, sputnikDeviceCode, name, attributes, status] = deviceData;
                const tSputDev = {sputnikdeviceid:sputnikdeviceid
                  ,sputnikDeviceCode:sputnikDeviceCode
                  ,attributes:fnJSONParse(attributes)
                  ,status:fnJSONParse(status)
                }
                // console.log(tLookup,sputnikDeviceCode,`[${sputnikDeviceCode}]`)
                // console.log(fnDictGetIndex(tLookup,sputnikDeviceCode,undefined,[]))
                fnDictGetIndex(tLookup,sputnikDeviceCode,undefined,[])?.forEach((nebulonTileID: string) => {
                  dispatch(setTileProperty({ nebulonTileID, keyaddress: 'sputnikDevice', keyvalue: tSputDev }));
                });                
                
              });
          
              // dispatch(setSpread(response.data))
          } else {
              throw new Error(`Server response was false: ${JSON.stringify(response.data)}`); 
          }
      })
    .catch(error => {
        console.error(error)
          // Handle errors from either API call
          // if (fnConsoleError) fnConsoleError("Unable to load initial data", error);
      });
  }